// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__RTXBZ","content":"SubHeader_content__xZCVM","btnBack":"SubHeader_btnBack__RE5cg","line":"SubHeader_line__3Jpya"};